import { GraphQLClient, gql } from 'graphql-request';
import { accessTokenManager } from '@mrkt/features/auth';
import { RequestDocument } from 'graphql-request/dist/types';

export { gql };

export async function request<Data = unknown, Variables = any>(
  query: RequestDocument,
  variables?: Variables,
) {
  const token = await accessTokenManager.get();

  const headers: { [k: string]: string } = {};

  if (token) {
    headers.authorization = `Bearer ${token}`;
  }

  const client = new GraphQLClient('/api/graphql', {
    headers,
  });

  return client.request<Data>(query, variables);
}
